import { Text } from '@myinterview/component-library';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
  messageType: 'IOS' | 'BROWSER' | 'INCOGNITO';
}

export const UnsupportedModal:React.FC<IProps> = ({ messageType }) => {
  const { t } = useTranslation();
  return (
    <div className="myinterview-widget-unsupported-modal">
      <Text className="myinterview-widget-unsupported-modal__message">{t(`setup.unsupported_device.${messageType}`)}</Text>
    </div>
  );
};
